import ClientService, {
  getHemisphereSessionToken,
  notifyHemisphereSessionExpired,
} from "./client-service";
import { CustomData } from "./model/customData"

class MetaInfoService extends ClientService {
  constructor() {
    super(process.env.VUE_APP_META_INFO_URL, {
      headerProvider() {
        const headers: any = {
          "Content-Type": "application/json",
        };
        const token = getHemisphereSessionToken();
        if (token) {
          headers["Authorization"] = "Bearer " + token;
        }
        return headers;
      },
      deconnectionHandler() {
        notifyHemisphereSessionExpired();
      },
    });
  }
  get(buildingId: string) {
    return this.client.get(`/data/${buildingId}`);
  }
  post(buildingId: string, data: CustomData[]) {
    const body = {
      "customData": data
    }
    return this.client.post(`/data/${buildingId}`, body)
  }
}
const metaInfoService = new MetaInfoService();

export default metaInfoService;
